import React, { useState, useContext } from 'react'
import './registration.css'
import Alert from '@mui/material/Alert';
import { ezStudentRegistration } from "../../services";
import { MyContext } from "../..";

export default function EzStudentRegistration(props) {
    document.title = props.title
    const queryParameters = new URLSearchParams(window.location.search)
    const mode = queryParameters.get("mode") || "light"
    const organisationCode = queryParameters.get("orgcode") || props.orgCode
    const subsciberCode = queryParameters.get("subcode") || props.subCode
    const { backendUrl } = useContext(MyContext);
    const formHeader = props.header || "Registration"
    const isUsername = props.isUsername

    const [formData, setFormData] = useState({
        // Initialize the form fields with default values or leave them empty
        firstName: "",
        lastName: "",
        username: "",
        email: "",
        password: "",
        password2: "",
        organizationCode: organisationCode,
        subsciberCode: subsciberCode
    });
    const [alert, setAlert] = useState({
        show: false,
        message: "",
        type: ""
    })

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        // You can handle form submission logic here
        const response = await ezStudentRegistration(backendUrl, formData);
        console.log("Account Created successfully");
        if (response.code === 201 || response.code === 200) {
            setAlert({
                type: "success",
                message: response.message,
                show: true,
            });
        } else {
            setAlert({
                type: "error",
                message: response.message,
                show: true,
            });
        }
    };
    return (
        <div className={`ez-registration-body ${mode === "dark" ? "m-dark-body" : ""}`}>
            {alert.show && <Alert variant={"outlined"} severity={alert.type} onClose={() => { setAlert({ show: false }) }} style={{ width: "45em", margin: "10px auto" }}>{alert.message}</Alert>}
            <div className={`ez-registration-container ${mode === "dark" ? "m-dark" : ""}`}>
                <div className="registration-title">{formHeader}</div>
                <form onSubmit={handleSubmit}>
                    <div className="form-fields">
                        {isUsername &&
                            <div className="registration-input">
                                <label htmlFor="ez-username">Username</label>
                                <input type="text" name="username" className="m-dark-input" id="ez-username" value={formData.username} onChange={handleChange} minLength={5} required />
                            </div>}
                        {/* <div className="registration-input">
                            <label htmlFor="ez-name">Name</label>
                            <input type="text" name="name" className="m-dark-input" id="ez-name" value={formData.name} onChange={handleChange} minLength={5} required />
                        </div> */}
                        <div className="registration-input">
                            <label htmlFor="ez-name">First Name</label>
                            <input type="text" name="firstName" className="m-dark-input" id="ez-name" value={formData.firstName} onChange={handleChange} minLength={5} required />
                        </div>
                        <div className="registration-input">
                            <label htmlFor="ez-name">Last Name</label>
                            <input type="text" name="lastName" className="m-dark-input" id="ez-name" value={formData.lastName} onChange={handleChange} minLength={5} required />
                        </div>
                        <div className="registration-input">
                            <label htmlFor="ez-email">Email</label>
                            <input type="email" name="email" className="m-dark-input" id="ez-email" value={formData.email} onChange={handleChange} required />
                        </div>
                        <div className="registration-input">
                            <label htmlFor="ez-password">Password</label>
                            <input type="password" name="password" className="m-dark-input" id="ez-password" value={formData.password} onChange={handleChange} minLength={5} required />
                        </div>
                        <div className="registration-input">
                            <label htmlFor="ez-password2">Confirm Password</label>
                            <input type="password" name="password2" className="m-dark-input" id="ez-password2" value={formData.password2} onChange={handleChange} required />
                        </div>
                    </div>
                    <button type='submit' className={`ez-btn ${mode === "dark" ? "m-dark-btn" : ""}`}>Register</button>
                </form>
                <div className="ez-registration-info">If you have already registered before or you have already an account, please <a href="/">Login</a></div>
                <div className="ez-registration-bottom-caption"></div>
            </div>
        </div>
    )
}
